import React from 'react';
import { navigate } from 'gatsby';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import Button from '../button';
import useTranslation from '../../../../hooks/useTranslation';

const BackButton = () => {
	const { t } = useTranslation();
	return (
		<div className="w-full">
			<Button
				onClick={() => navigate(-1)}
				className="cursor-pointer text-lg font-bold text-brand flex items-center gap-1">
				<ChevronLeftIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
				{t('pages.utilities.back')}
			</Button>
		</div>
	);
};

export default BackButton;
